var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.onboardingStatus == null)?_c('div',{staticClass:"loading-skeleton"},[_c(_setup.Spinner)],1):(_setup.onboardingStatus === _setup.OnboardingStatus.UNSUPPORTED_COUNTRY)?_c(_setup.UnsupportedCountry):(_setup.onboardingStatus === _setup.OnboardingStatus.GLOBAL)?_c(_setup.GlobalHome):_c(_setup.OnboardedHome)
}
var staticRenderFns = []

export { render, staticRenderFns }